import { useEffect, useState } from "react";

//helper
import sortByDate from "../helpers/sortByDate";

const useSortContent = (content, type) => {
	const [sortedContent, setSortedContent] = useState([]);



	useEffect(() => {
		if (content) {
			let arrayCopy = [...content];

			if (type == "date") {
				return setSortedContent(arrayCopy.sort(sortByDate));
			}

			if (type == "alphabetically-reverse") {
				return setSortedContent(arrayCopy.reverse());
			}

			return setSortedContent(arrayCopy);
		}
		
	}, [content, type]);

	return sortedContent;
};

export default useSortContent;
